module.exports = __webpack_public_path__ + "static/img/SG.d99b4b1d.png";